import { useContext } from "react";
import { AuthContext } from "../services/authcontext";

export default function useIsRoleUser() {
  const { user } = useContext(AuthContext);
  return user?.roles?.some((role) => role.name === "ROLE_USER") ?? false;
}
